<div class="position-relative">
  <h2 class="name" [class.loading]="loading">
    <span *ngIf="name" class="name text-truncate d-block" [class.loading]="loading">{{ name }}</span>
  </h2>
  <div class="companyContactsContainer d-flex flex-column flex-md-row">
    <div *ngIf="email" class="contactsInnerContainer w-lg-50 webaddress ml-md-3" [class.loading]="loading">
      <p class="webaddress internet-icon icon icon">
        <span class="webaddress">{{ email }}</span>
      </p>
    </div>
  </div>
</div>
